import angular from 'angular';

import Component from './bar-graph.component';

const BarGraph = angular
    .module('control-room.commons.data.components.bar-graph', [])
    .component('crBarGraph', Component);

export default BarGraph;
